<footer class="bg-white border-t border-primary-100 animate-fadeIn">
  <div class="max-w-7xl mx-auto px-4 py-6">
    <div class="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
      <div class="flex items-center space-x-2">
        <div class="relative w-8 h-8 animate-pulse">
          <div
            class="absolute inset-0 bg-gradient-to-r from-primary-400 to-primary-500 rounded-lg blur opacity-30"
          ></div>
          <div
            class="relative w-full h-full rounded-lg bg-gradient-to-r from-primary-50 to-primary-100 flex items-center justify-center border border-primary-200"
          >
            <span
              class="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-700 font-bold text-sm"
              >R</span
            >
          </div>
        </div>
        <p class="text-gray-500 text-sm">
          © 2023
          <span
            class="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-700 font-medium hover:from-primary-700 hover:to-primary-600 transition-all duration-500"
          >
            Rectilineus Admin
          </span>
        </p>
      </div>
    </div>
  </div>
</footer>
